var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMasterCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.54292 0.853516H5.0293V7.14312H8.54292V0.853516Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25438 3.99902C5.25383 3.39329 5.39163 2.79537 5.65734 2.25053C5.92306 1.70568 6.30974 1.2282 6.7881 0.854225C6.19572 0.390407 5.48429 0.101966 4.73512 0.0218685C3.98595 -0.0582284 3.22927 0.0732481 2.55158 0.401277C1.87388 0.729305 1.3025 1.24065 0.902749 1.87686C0.503002 2.51307 0.291016 3.24848 0.291016 3.99902C0.291016 4.74957 0.503002 5.48498 0.902749 6.12119C1.3025 6.7574 1.87388 7.26874 2.55158 7.59677C3.22927 7.9248 3.98595 8.05628 4.73512 7.97618C5.48429 7.89608 6.19572 7.60764 6.7881 7.14382C6.30974 6.76984 5.92307 6.29236 5.65735 5.74752C5.39163 5.20268 5.25383 4.60476 5.25438 3.99902Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2859 3.99902C13.286 4.74956 13.074 5.48496 12.6743 6.12117C12.2746 6.75738 11.7032 7.26873 11.0255 7.59676C10.3478 7.92479 9.59116 8.05627 8.842 7.97618C8.09285 7.89608 7.38143 7.60764 6.78906 7.14382C7.267 6.76947 7.65337 6.29191 7.91905 5.74715C8.18472 5.20239 8.32277 4.60466 8.32277 3.99902C8.32277 3.39339 8.18472 2.79565 7.91905 2.25089C7.65337 1.70614 7.267 1.22858 6.78906 0.854224C7.38143 0.390405 8.09285 0.101963 8.842 0.0218675C9.59116 -0.0582285 10.3478 0.0732539 11.0255 0.401286C11.7032 0.729318 12.2746 1.24066 12.6743 1.87687C13.074 2.51308 13.286 3.24848 13.2859 3.99902Z",
    fill: "#F79E1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9029 6.4785V6.34973H12.955V6.3235H12.8223V6.34973H12.8744V6.4785H12.9029ZM13.1606 6.4785V6.32324H13.1199L13.0731 6.43003L13.0263 6.32324H12.9856V6.4785H13.0143V6.36139L13.0582 6.46235H13.088L13.1319 6.36113V6.4785H13.1606Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/master-card.877e180d73253a837e7f9a4931a78d83.svg";
export { ForwardRef as ReactComponent };